import React from 'react';
import {connect} from 'react-redux'
import {CompanySelector} from '/app/src/model';

import DashboardCompany from './DashboardCompany'

class DashboardCompanyContainer extends React.Component {
    render() {
        const { activePlan } = this.props
        return <DashboardCompany activePlan={activePlan}/>
    }
}

function mapStateToProps(state, props) {
    return {
        activePlan: CompanySelector.getPaymentPlan(state)
    }
}

export default connect(mapStateToProps, null)(DashboardCompanyContainer);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Upgrade/index.js